module.exports = __webpack_public_path__ + "494cd07c/img/cadBim.e369a02a.png";